// Groups the fine-grained company categories (src/util/translation/*/common.json
// "Category" section) into broader industry groups for reporting/breakdowns.
// Labels for the group keys live under the "CategoryGroup" translation section.
export const CATEGORY_GROUPS = {
  BUSINESS_TECH_SERVICES: [
    'IT',
    'INFORMATION',
    'COMMUNICATIONS',
    'TELECOM',
    'LAWYERS',
    'CONSULTANCY',
    'STAFFING',
    'SECURITY',
    'CLEANING_SERVICES',
  ],
  FINANCE_INSURANCE: [
    'BANKING',
    'FINANCE',
    'INSURANCE',
    'ACCOUNTING',
    'AUDITING',
  ],
  CONSTRUCTION_INDUSTRY_PROPERTY: [
    'CONSTRUCTION',
    'ARCHITECTURE',
    'ENGINEERING',
    'TRADESPERSON',
    'INDUSTRY',
    'MANUFACTURING',
    'PROPERTY',
    'ENERGY',
    'POWER',
    'RECYCLING',
    'ENVIRONMENT',
  ],
  RETAIL_FOOD_HOSPITALITY: [
    'FOOD',
    'DRINKS',
    'RESTAURANTS',
    'CATERING',
    'GROCERY',
    'ACCOMMODATION',
    'TRAVEL',
    'SHOPPING',
    'RETAIL',
    'TRADE',
    'ECOMMERCE',
    'OFFICE SUPPLIES',
    'FASHION',
  ],
  MEDIA_SPORT_LEISURE: [
    'ADVERTISING',
    'MARKETING',
    'MEDIA',
    'EVENTS',
    'ENTERTAINMENT',
    'CULTURE',
    'GAMES',
    'BETTING',
    'SPORT',
    'LEISURE',
  ],
  HEALTH_EDUCATION_PUBLIC: [
    'HEALTH',
    'HEALTHCARE',
    'WELLBEING',
    'PHARMACY',
    'DENTAL_CARE',
    'CARE_SERVICES',
    'CHILDCARE',
    'PUBLIC_SECTOR',
    'NON_PROFIT',
    'ASSOCIATIONS',
    'EDUCATION',
  ],
  TRANSPORT_PRIMARY: [
    'TRANSPORT',
    'LOGISTICS',
    'AUTOMOTIVE',
    'AGRICULTURE',
    'FORESTRY',
    'FISHING_AQUACULTURE',
  ],
  OTHER: ['OTHER'],
};

const CATEGORY_TO_GROUP = Object.entries(CATEGORY_GROUPS).reduce(
  (acc, [group, categories]) => {
    categories.forEach((category) => {
      acc[category] = group;
    });
    return acc;
  },
  {}
);

export const getCategoryGroup = (category) =>
  CATEGORY_TO_GROUP[category] || 'OTHER';
